import { cn } from '@/utils/cn';

interface CheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
}

export const Checkbox = ({ checked = false, onChange, className }: CheckboxProps) => {
  const handleClick = () => {
    onChange?.(!checked);
  };

  return (
    <div className={cn('flex', className)}>
      <div
        className={cn(
          'relative w-4.5 h-4.5 rounded border-1 cursor-pointer transition-colors duration-200',
          'flex items-center justify-center',
          checked
            ? 'bg-selected-border border-selected-border checkbox-box--checked'
            : 'bg-white border-base-border hover:border-selected-border'
        )}
        onClick={handleClick}
      >
        {checked && (
          <svg className="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={3}>
            <path
              className="checkbox-check"
              pathLength={1}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        )}
      </div>
    </div>
  );
};
